var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3215.95 2533.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#95d4e9;}.cls-2{fill:#00369c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1763.71V752.78H490.91q76.69,0,141.9,29.9T745.56,861A364.22,364.22,0,0,1,820,970.63q26.84,61.23,26.85,123.88a331.26,331.26,0,0,1-12.27,90.41,337.12,337.12,0,0,1-35.29,81.87,312.71,312.71,0,0,1-56,69,333.18,333.18,0,0,1-74.4,52l239.31,375.89H624.37L415.74,1437.65H251.59v326.06ZM251.59,1234H481.7q44.49,0,76.71-39.16t32.21-100.37q0-62.64-36.82-99.67t-79.77-37H251.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1026.09,1763.71V752.78h251.6V1763.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1949.12,690.64c-317.72,0-576.2,258.48-576.2,576.19S1631.4,1843,1949.12,1843s576.19-258.49,576.19-576.2S2266.83,690.64,1949.12,690.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2140.06,1188.76l-17.37-9.86a217.35,217.35,0,0,1-54.41,51.93l36.91,21c.73.41,1.45.79,2.19,1.15.38.17,37.36,18.93,39.81,55.4v233.41a13.25,13.25,0,0,1-13.28,13.19H1764.32a13.24,13.24,0,0,1-13.27-13.19V1308.33c2.42-36.19,38.52-54.75,39.78-55.4.78-.37,1.53-.76,2.27-1.18l36.69-21a217.88,217.88,0,0,1-54.29-51.88l-17.39,9.93c-11.15,5.78-75.15,42.2-79,116.62,0,.63,0,236.34,0,236.34a85.35,85.35,0,0,0,85.29,85.22h369.59a85.35,85.35,0,0,0,85.3-85.22s0-235.71-.05-236.34C2215.25,1230.87,2151.05,1194.46,2140.06,1188.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1949.12,
    cy: 158.35,
    r: 158.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1949.12,
    cy: 2375.31,
    r: 158.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3057.6,
    cy: 1266.83,
    r: 158.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1949.12,1194.81c79.43,0,144.05-64.62,144.05-144v-72c0-79.43-64.62-144-144.05-144s-144,64.62-144,144v72C1805.07,1130.19,1869.69,1194.81,1949.12,1194.81Zm-72-216.07a72,72,0,1,1,144.05,0v72a72,72,0,0,1-144.05,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1165.34,
    cy: 483.06,
    r: 158.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2732.89,
    cy: 483.06,
    r: 158.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1165.34,
    cy: 2050.56,
    r: 158.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2732.89,
    cy: 2050.56,
    r: 158.35
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRio);
export default __webpack_public_path__ + "static/media/Logo-RIO.7c7997e542aabc166320fdc4ba433cc2.svg";
export { ForwardRef as ReactComponent };